export const PreOrderFulfillmentStatus = {
    "UNACCEPTED": 0,
    "IN_PROGRESS": 1,
    "COMPLETED": 2,
    "DELIVERED": 3
  }